<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Media Library</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
    <div class="divider"></div>

    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>
<div class="media-library">

  <!-- LIST -->
  <div class="container media-list-container">
    <div class="container-header no-bottom-border">
      <div class="text">Asset list</div>
    </div>
    <div
      class="container-content"
      lhpeElementLoader
      #mediaElementLoader="elementloader"
    >
      <table #mediaTable mat-table [dataSource]="mediasDataSource" matSort>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            {{ row.description ? row.description : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>File Name</th>
          <td mat-cell *matCellDef="let row">
            {{ row.name ? row.name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="context">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let row">
            {{ getMediaType(row.context) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="created_by_name">
          <th mat-header-cell *matHeaderCellDef>Uploaded by</th>
          <td mat-cell *matCellDef="let row">
            {{ row.created_by_name ? row.created_by_name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="options-cell">
            <button mat-button (click)="viewMedia(row)" class="icon-btn">
              <svg-icon
                src="assets/svg/view.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <button
              *ngIf="showCreateAndEdit"
              mat-button
              (click)="editMedia(row)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <button
              *ngIf="showRemove"
              class="icon-btn"
              mat-button
              (click)="deleteMedia(row)"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>

  <div class="utility">

    <!-- UPLOAD -->
    <div class="container upload-container">

      <div class="container-header no-bottom-border">
        <div *ngIf="!isPreview" class="text">
          {{ isEdit ? "Edit Media" : "Upload Media" }}
        </div>
        <div *ngIf="isPreview" class="text">Preview Media</div>
      </div>
      <div class="container-content">
        <lhpe-select
          *ngIf="!isPreview"
          controlName="mediaUploadType"
          placeholder="Type"
          [formGroup]="uploadMediaForm!"
          [options]="mediaUploadTypeOptions"
        >
        </lhpe-select>
        <ng-container *ngIf="uploadMediaForm.controls.mediaUploadType.value">
          <lhpe-input
            *ngIf="!isPreview"
            class="input desc-input"
            controlName="desc"
            placeholder="Image Name"
            [formGroup]="uploadMediaForm!"
            [required]="true"
          >
          </lhpe-input>
  
          <div class="center">
            <ngx-file-drop
              *ngIf="!isPreview && !filePreviewUrl"
              dropZoneLabel="Drop files here"
              accept=".png,.jpg,.jpeg,.svg"
              [directory]="false"
              [multiple]="false"
              (onFileDrop)="dropped($event)"
            >
              <ng-template
                ngx-file-drop-content-tmp
                let-openFileSelector="openFileSelector"
              >
                <button
                  mat-button
                  class="icon-btn upload-icon"
                  (click)="openFileSelector()"
                >
                  <svg-icon src="assets/svg/image-upload.svg"></svg-icon>
                </button>
                <div class="">
                  {{
                    isEdit
                      ? "Drag and drop a new image to replace the current one"
                      : "Drag and drop image here"
                  }}
                </div>
                <div class="">- or -</div>
                <div class="">click to browse files</div>
              </ng-template>
            </ngx-file-drop>

            <ng-container *ngIf="filePreviewUrl; else existingImagePreview">
              <img class="preview" [src]="filePreviewUrl" />
            </ng-container>
            <ng-template #existingImagePreview>
              <img *ngIf="currentMedia" class="preview" [src]="currentMedia.url" />
            </ng-template>
            <div *ngIf="file; else existingFileInfo" class="optimal-size">
              {{ file.name }}
            </div>
            <ng-template #existingFileInfo>
              <div *ngIf="currentMedia" class="optimal-size">
                {{ currentMedia.name }}
              </div>
            </ng-template>
            <div *ngIf="file && imageWidth && imageHeight" class="optimal-size">
              {{ imageWidth }}px wide x {{ imageHeight }}px tall
            </div>
            <div
              *ngIf="!file && isEdit && currentHeight && currentWidth"
              class="optimal-size"
            >
              {{ currentWidth }}px wide x {{ currentHeight }}px tall
            </div>
            <div *ngIf="!isPreview" class="optimal-size">
              Optimal image size: {{ optimalWidth(uploadMediaForm) }}px wide x
              {{ optimalHeight(uploadMediaForm) }}px tall
            </div>
            <div *ngIf="singleUseTypeAlreadyExists && !isEdit" class="single-use-warning">
              A {{ typeName }} image already exists. Only one is allowed per account.
            </div>
            <div class="button-row">
              <button
                *ngIf="!isEdit"
                mat-button
                color="lightGreen"
                [disabled]="uploadDisabled"
                (click)="uploadImage()"
              >
                Upload image
              </button>
              <button
                *ngIf="isEdit && !isPreview"
                mat-button
                color="lightGreen"
                [disabled]="editDisabled"
                (click)="updateMedia()"
              >
                Save
              </button>
              <button mat-button color="fiord" (click)="cancel()">
                {{ !isPreview ? "Cancel" : "Close" }}
              </button>
            </div>
          </div>
        </ng-container>
      </div>
  
    </div>

    <!-- GENERATE -->
    <div class="container generate-container" *ngIf="imageGenIntegration !== null && imageGenIntegration !== undefined && !isPreview">
      <div class="container-header no-bottom-border">
        <div class="text"><svg-icon
          class="icon"
          src="assets/svg/core-dark.svg"
          [svgStyle]="{
            'width.px': '18',
            'height.px': '18'
          }"
        ></svg-icon> Generate Media</div>
      </div>
      <div class="container-content">
        <div class="field">
          <lhpe-select
            controlName="mediaUploadType"
            placeholder="Type"
            [formGroup]="imageGenForm!"
            [options]="imageGenerationOptions"
          >
          </lhpe-select>
        </div>

        <div class="field" *ngIf="imageGenForm.controls.mediaUploadType.value">
          <lhpe-input
            class="input desc-input"
            controlName="name"
            placeholder="Image Name"
            [formGroup]="imageGenForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>
        
        <div class="field" *ngIf="imageGenForm.controls.mediaUploadType.value">
          <lhpe-textarea
            *ngIf="!isPreview"
            class="input desc-input"
            controlName="desc"
            placeholder="Describe the image you want to generate"
            [formGroup]="imageGenForm!"
            [rows]="3"
            [required]="true"
          >
          </lhpe-textarea>
        </div>

        <button mat-button color="lightGreen" [disabled]="!imageGenForm.valid" *ngIf="imageGenForm.controls.mediaUploadType.value" (click)="generateImage()">Generate</button>
      </div>
    </div>
  </div>

  
</div>
